import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		
	},
	getters: {
		
	},
	mutations: {
		
	},
	actions: {
		async getDc0(store, dc0arquivo){
			return await this._vm.$axios.get("/Dictionary/Dictionary/FindDC0ByDc0arquivo/"+dc0arquivo)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async getDc1(store, dc1arquivo){
			return await this._vm.$axios.get("/Dictionary/Dictionary/FindDC1ByDc1arquivo/"+dc1arquivo)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async getMultipleDc0(store, lstDc0arquivo) {
			let query = ""
			for (let index = 0; index < lstDc0arquivo.length; index++) {
				const dc0arquivo = lstDc0arquivo[index];
				query += `dc0arquivo=${dc0arquivo}&`
			}
			return await this._vm.$axios.get("/Dictionary/Dictionary/FindDC0ByLstDc0arquivo?"+query)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async getMultipleDc1(store, lstDc1arquivo) {
            if(!lstDc1arquivo)
                return []
            let query = ""
			for (let index = 0; index < lstDc1arquivo.length; index++) {
				const dc1arquivo = lstDc1arquivo[index];
				if (index > 0 ) query += "&"
				query += `dc1arquivo=${dc1arquivo}` 
			}
			return await this._vm.$axios.get("/Dictionary/Dictionary/FindDC1ByLstDc1arquivo?"+query)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async getNextNumber(store, field) {
			return await this._vm.$axios.get("/Dictionary/Dictionary/GetNextNumber/"+field)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async findDc9(store, dc9relat){
			return await this._vm.$axios.get(`/Dictionary/Report/Find/${dc9relat}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async isFileBlocked(store, dc0arquivo){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Verificando bloqueio por ordem de produção em andamento", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.get(`/Dictionary/Dictionary/IsFileBlocked/${dc0arquivo}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return true
			});

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload;
		}
	}
}